import { Reveal } from "@/components/Reveal";
import { LegalNotice } from "@/components/LegalNotice";
import { AGB } from "@/data/site";

export default function Agb() {
  return (
    <div data-testid="agb-page" className="pt-32 pb-24 md:pb-32">
      <div className="mx-auto max-w-[820px] px-5 md:px-10">
        <Reveal>
          <span className="text-xs uppercase tracking-[0.25em] text-muted-foreground">Rechtliches</span>
          <h1 className="font-serif font-light text-5xl md:text-7xl tracking-tighter mt-5">AGB</h1>
          <p className="mt-5 text-foreground/70">Allgemeine Geschäftsbedingungen · Maschas Atelier</p>
        </Reveal>

        <Reveal delay={0.05}><LegalNotice /></Reveal>

        <Reveal delay={0.1}>
          <div className="mt-12 divide-y divide-border border-t border-border">
            {AGB.map((s) => (
              <div key={s.title} className="py-6">
                <h3 className="font-serif text-xl md:text-2xl text-foreground mb-2">{s.title}</h3>
                <p className="text-foreground/80 leading-relaxed whitespace-pre-line">{s.body}</p>
                {s.link && (
                  <a
                    href={s.link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="agb-widerruf-link"
                    className="mt-3 inline-flex items-center gap-2 text-sm text-primary underline underline-offset-4 hover:opacity-80 transition-opacity"
                  >
                    {s.link.label}
                  </a>
                )}
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  );
}
